import React, { useEffect, useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import Header from '../components/Header';
import { CheckCircle, Loader2, Mail, Clock, FileText } from 'lucide-react';

const PaymentSuccessPage = () => {
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get('session_id');
  const method = searchParams.get('method');
  const [status, setStatus] = useState('checking');
  const [paymentInfo, setPaymentInfo] = useState(null);

  const backendUrl = process.env.REACT_APP_BACKEND_URL || '';

  useEffect(() => {
    const checkPaymentStatus = async () => {
      if (!sessionId || method !== 'stripe') {
        setStatus('success'); // For PayPal or direct success
        return;
      }

      try {
        const response = await fetch(`${backendUrl}/api/payment-status/${sessionId}`);
        if (response.ok) {
          const data = await response.json();
          setPaymentInfo(data);
          if (data.payment_status === 'paid') {
            setStatus('success');
          } else {
            // Poll again after delay
            setTimeout(checkPaymentStatus, 2000);
          }
        }
      } catch (error) {
        console.error('Error checking payment:', error);
        setStatus('success'); // Assume success if we can't check
      }
    };

    checkPaymentStatus();
  }, [sessionId, method, backendUrl]);

  return (
    <div className="min-h-screen bg-[#0f0f1a]">
      <Header />
      <main className="pt-28 pb-16 px-4">
        <div className="max-w-xl mx-auto text-center">
          {status === 'checking' ? (
            <div>
              <Loader2 className="h-16 w-16 text-cyan-400 animate-spin mx-auto mb-6" />
              <h1 className="text-2xl font-bold text-white mb-2">Verifica Pagamento in Corso...</h1>
              <p className="text-gray-400">Attendere prego</p>
            </div>
          ) : (
            <div>
              <div className="w-24 h-24 bg-green-500/20 rounded-full flex items-center justify-center mx-auto mb-6">
                <CheckCircle className="h-12 w-12 text-green-400" />
              </div>
              
              <h1 className="text-3xl font-bold text-white mb-4">
                Pagamento Completato! 🎉
              </h1>
              
              <p className="text-gray-300 text-lg mb-8">
                Grazie per il tuo acquisto. Il tuo ordine è stato elaborato con successo.
              </p>

              <div className="bg-[#1a1a2e] rounded-xl p-6 mb-8 text-left border border-gray-700">
                <h2 className="text-lg font-semibold text-white mb-4 flex items-center gap-2">
                  <FileText className="h-5 w-5 text-cyan-400" />
                  Cosa succede ora?
                </h2>
                <ul className="space-y-4">
                  <li className="flex items-start gap-3">
                    <Mail className="h-5 w-5 text-cyan-400 mt-0.5" />
                    <div>
                      <p className="text-white font-medium">Email di Conferma</p>
                      <p className="text-gray-400 text-sm">Riceverai una email con il riepilogo dell'ordine</p>
                    </div>
                  </li>
                  <li className="flex items-start gap-3">
                    <Clock className="h-5 w-5 text-cyan-400 mt-0.5" />
                    <div>
                      <p className="text-white font-medium">Elaborazione Report</p>
                      <p className="text-gray-400 text-sm">Il nostro team inizierà l'analisi entro poche ore</p>
                    </div>
                  </li>
                  <li className="flex items-start gap-3">
                    <FileText className="h-5 w-5 text-cyan-400 mt-0.5" />
                    <div>
                      <p className="text-white font-medium">Consegna Report</p>
                      <p className="text-gray-400 text-sm">Riceverai il report completo via email entro 24 ore</p>
                    </div>
                  </li>
                </ul>
              </div>

              {paymentInfo && (
                <div className="bg-[#1a1a2e] rounded-xl p-4 mb-8 border border-gray-700">
                  <p className="text-gray-400 text-sm">
                    Importo pagato: <span className="text-white font-bold">€{paymentInfo.amount?.toFixed(2)}</span>
                  </p>
                </div>
              )}

              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <Link 
                  to="/"
                  className="px-6 py-3 bg-gradient-to-r from-red-500 to-orange-500 text-white rounded-lg font-medium hover:opacity-90 transition-all"
                >
                  Nuova Analisi
                </Link>
                <a 
                  href="mailto:cyber@smart-info.it"
                  className="px-6 py-3 bg-gray-700 hover:bg-gray-600 text-white rounded-lg font-medium transition-colors"
                >
                  Contattaci
                </a>
              </div>
            </div>
          )}
        </div>
      </main>
    </div>
  );
};

export default PaymentSuccessPage;
